function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/* eslint-disable new-cap */
import olLayerVectorTile from 'ol/layer/VectorTile';
import olLayerTile from 'ol/layer/Tile';
import olSourceTileDebug from 'ol/source/TileDebug';
import olFormatMVT from 'ol/format/MVT';
import olTileGrid from 'ol/tilegrid/TileGrid';
import olSourceVectorTile from 'ol/source/VectorTile';
import { getMVTFeaturesInExtent } from 'oskari-frontend/bundles/mapping/mapmodule/util/vectorfeatures/mvtHelper';
import { WFS_ID_KEY } from 'oskari-frontend/bundles/mapping/mapmodule/domain/constants';
import { AbstractLayerHandler, LOADING_STATUS_VALUE } from './AbstractLayerHandler.ol';
import { RequestCounter } from './RequestCounter';

/**
 * @class MvtLayerHandler
 * LayerHandler implementation for MVT layers
 */
export var MvtLayerHandler = /*#__PURE__*/function (_AbstractLayerHandler) {
  function MvtLayerHandler(layerPlugin) {
    var _this;
    _classCallCheck(this, MvtLayerHandler);
    _this = _callSuper(this, MvtLayerHandler, [layerPlugin]);
    _this._log = Oskari.log('WfsMvtLayerPlugin');
    _this.localization = Oskari.getMsg.bind(null, 'MapWfs2');
    var config = layerPlugin.getConfig();
    if (!config) {
      return _possibleConstructorReturn(_this);
    }
    _this.minZoomLevel = _this._getMinZoom(config);
    _this._setupTileGrid(config);
    return _this;
  }
  _inherits(MvtLayerHandler, _AbstractLayerHandler);
  return _createClass(MvtLayerHandler, [{
    key: "addMapLayerToMap",
    value: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
      _superPropGet(MvtLayerHandler, "addMapLayerToMap", this, 3)([layer, keepLayerOnTop, isBaseMap]);
      var sourceOpts = {
        format: new olFormatMVT(),
        projection: this.plugin.getMap().getView().getProjection(),
        url: layer.getLayerUrl().replace('{epsg}', this.plugin.getMapModule().getProjection())
      };
      if (this.tileGrid) {
        sourceOpts.tileGrid = new olTileGrid(this.tileGrid);
      }
      var layerMinScale = layer.getMinScale() && layer.getMinScale() > 0 ? layer.getMinScale() : undefined;
      var mvtMinScale = this._getMinScale();
      if (mvtMinScale && (!layerMinScale || layerMinScale > mvtMinScale)) {
        layer.setMinScale(mvtMinScale);
      }
      var source = new olSourceVectorTile(sourceOpts);
      var vectorTileLayer = new olLayerVectorTile({
        opacity: layer.getOpacity() / 100,
        visible: layer.isVisible(),
        renderMode: 'hybrid',
        source: source
      });
      this._registerLayerEvents(layer.getId(), source);
      var hoverLayer = this.plugin.vectorFeatureService.registerHoverLayer(layer, source);
      var olLayers = [vectorTileLayer, hoverLayer];
      this.plugin.setOLMapLayers(layer.getId(), olLayers);
      return olLayers;
    }
  }, {
    key: "_getFeaturesInViewport",
    value: function _getFeaturesInViewport(layerId) {
      var source = this._getLayerSource(layerId);
      if (!source) {
        return [];
      }
      var _this$plugin$getSandb = this.plugin.getSandbox().getMap().getBbox(),
        left = _this$plugin$getSandb.left,
        bottom = _this$plugin$getSandb.bottom,
        right = _this$plugin$getSandb.right,
        top = _this$plugin$getSandb.top;
      var extent = [left, bottom, right, top];
      return getMVTFeaturesInExtent(source, extent, WFS_ID_KEY) || [];
    }
  }, {
    key: "_getMinZoom",
    value: function _getMinZoom(config) {
      if (!config.minZoomLevel || !Array.isArray(config.resolutions)) return 0;
      var minResolution = config.resolutions[config.minZoomLevel];
      var mapModule = Oskari.getSandbox().findRegisteredModuleInstance('MainMapModule');
      var mapResolutions = mapModule.getResolutionArray();
      for (var z = 1; z < mapResolutions.length; z++) {
        var curr = mapResolutions[z];
        if (curr === minResolution) {
          return z;
        }
        if (curr < minResolution) {
          var dcurr = Math.abs(curr - minResolution);
          var dprev = Math.abs(mapResolutions[z - 1] - minResolution);
          return dcurr < dprev ? z : z - 1;
        }
      }
      return mapResolutions.length - 1;
    }
  }, {
    key: "refreshLayer",
    value: function refreshLayer(layer) {
      var source = this._getLayerSource(layer);
      source.tileCache.expireCache({});
      source.tileCache.clear();
      source.clear();
      source.refresh();
      this._log.warn('Server caches MVT-rendered tiles, use GeoJSON for layers that need to be updated at runtime or add a way to update cache on server.');
    }
  }, {
    key: "_setupTileGrid",
    value: function _setupTileGrid(config) {
      var origin = config.origin,
        resolutions = config.resolutions,
        tileSize = config.tileSize;
      if (!origin || !resolutions || !tileSize) {
        return;
      }
      this.tileGrid = {
        origin: origin,
        resolutions: resolutions,
        tileSize: [tileSize, tileSize]
      };
    }

    /**
     * @method _createDebugLayer Helper for debugging purposes.
     * Use from console. Set breakpoint when new olSourceVectorTile() is called
     *  and add desired layer to map.
     *
     * Like so:
     * Set breakpoint on "const source = new olSourceVectorTile(options);"
     * Call this._createDebugLayer(source)
     * @param {ol.source.TileDebug} source layer source
     */
  }, {
    key: "_createDebugLayer",
    value: function _createDebugLayer(source) {
      this.plugin.getMapModule().getMap().addLayer(new olLayerTile({
        source: new olSourceTileDebug({
          projection: this.plugin.getMapModule().getMap().getView().getProjection(),
          tileGrid: source.getTileGrid()
        })
      }));
    }
  }, {
    key: "_getMinScale",
    value: function _getMinScale() {
      if (!this.minZoomLevel) {
        return;
      }
      if (this.minZoomLevel > this.plugin.getMapModule().getScaleArray().length - 1) {
        return;
      }
      var zoomLevelScale = this.plugin.getMapModule().getScaleArray()[this.minZoomLevel];
      // Min scale is exclusive on layer visibility.
      // Add +1 to make a layer visible at the zoom level.
      return zoomLevelScale + 1;
    }

    /**
     * Adds event listeners to ol-layers
     * @param {string|number} layerId
     * @param {ol/source/VectorTile} oskariLayer
     */
  }, {
    key: "_registerLayerEvents",
    value: function _registerLayerEvents(layerId, source) {
      var _this2 = this;
      var counter = new RequestCounter();
      source.on('tileloadstart', function () {
        counter.update(LOADING_STATUS_VALUE.LOADING);
        _this2.tileLoadingStateChanged(layerId, counter);
      });
      source.on('tileloadend', function () {
        counter.update(LOADING_STATUS_VALUE.COMPLETE);
        _this2.tileLoadingStateChanged(layerId, counter);
      });
      source.on('tileloaderror', function () {
        counter.update(LOADING_STATUS_VALUE.ERROR);
        _this2.tileLoadingStateChanged(layerId, counter);
      });
    }
  }]);
}(AbstractLayerHandler);